<ng-container>
    <input type="file" id="fileLoader" name="logo" accept=".jpeg, .jpg, .png, .bmp, .webp" #upload (change)="uploadOpen($event)" hidden>
    <div class="button" [ngClass]="{'disabled': activeProgress, 'ask': !activeProgress}" matRipple [matRippleDisabled]="activeProgress" (click)="upLoad()" [attr.disabled]="activeProgress">
        <img class="w-12 h-12" [src]="getClientImage()" loading="lazy" (error)="imgStore.src = defaultClientIcon" #imgStore>
    </div>
</ng-container>
